<template>
	<div>
		<app-drawer v-model="drawer" />
		<v-app-bar app flat>
			<v-app-bar-nav-icon @click="drawer = !drawer" />
			<v-toolbar-title>{{ title }}</v-toolbar-title>
			<v-spacer />
			<v-btn
				:class="isLoggedIn ? 'help-btn' : ''"
				text
				href="https://our-sci.gitlab.io/software/soilstack-tutorials/"
				target="_blank"
			>
				<v-icon size="22">mdi-help-circle-outline</v-icon>
			</v-btn>
			<navbar-user-menu v-if="isLoggedIn" />
		</v-app-bar>
	</div>
</template>

<script>
import { defineComponent, onUnmounted, ref } from '@vue/composition-api';
import AppDrawer from '@/components/common/AppDrawer.vue';
import NavbarUserMenu from '@/views/auth/NavbarUserMenu.vue';
import { AuthService } from '../../services/storageService';

export default defineComponent({
	components: {
		AppDrawer,
		NavbarUserMenu,
	},
	props: {
		title: String,
	},
	setup() {
		const isLoggedIn = ref(Boolean(AuthService.getToken()));

		const onAuthServiceTokenChange = () => {
			isLoggedIn.value = Boolean(AuthService.getToken());
		};

		window.addEventListener('authservicetokenchange', onAuthServiceTokenChange);

		onUnmounted(() => {
			window.removeEventListener('authservicetokenchange', onAuthServiceTokenChange);
		});

		return {
			drawer: ref(false),
			isLoggedIn,
		};
	},
});
</script>

<style>
.v-toolbar__content {
	padding-right: 0 !important;
}

.help-btn.v-btn:not(.v-btn--round).v-size--default {
	min-width: 0px;
	padding: 0px 8px;
}
</style>
